import React, { FC, memo, useCallback, useEffect } from 'react';
import testIds from '@smart-tv/e2e/shared/variables';

import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import Button from '@smart-tv/components/button/button';
import Typography from '@smart-tv/components/typography/typography';

import useFavoritesEdit from '@smart-tv/hooks/use-favorites-edit';
import useFavoritesLists from '@smart-tv/hooks/use-favorites-lists';

import { FavoritesScreen } from '@smart-tv/contexts/favorites-edit-context/favorites-edit-context';
import styles from './favorites.module.scss';

export const FavoritesDelete: FC = () => {
  const { ref, focusKey, focusSelf } = useFocusable({ isFocusBoundary: true });

  const { onDeleteFavoritesList } = useFavoritesLists();
  const { editedFavoritesList, handleSelectScreen } = useFavoritesEdit();

  const handleDelete = useCallback(() => {
    if (editedFavoritesList) {
      onDeleteFavoritesList(editedFavoritesList);
      handleSelectScreen(FavoritesScreen.Home);
    }
  }, [editedFavoritesList, handleSelectScreen, onDeleteFavoritesList]);

  useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div
        className={styles['favorites-delete-layout']}
        ref={ref}
        data-testid={testIds.favorites.delete.root}
      >
        <Typography
          className={styles['favorites-delete-root--title']}
          variant="h1"
          data-testid={testIds.favorites.delete.title}
        >
          Er du sikker på, at du vil slette?
        </Typography>
        <Typography
          className={styles['favorites-delete-root--name']}
          variant="h3"
          data-testid={testIds.favorites.delete.listTitle}
        >
          {editedFavoritesList?.name}
        </Typography>
        <Button
          className={styles['favorites-delete-root--button']}
          onClick={handleDelete}
          data-testid={testIds.favorites.delete.submit}
        >
          Slet listen
        </Button>
        <Button
          className={styles['favorites-delete-root--button']}
          onClick={() => handleSelectScreen(FavoritesScreen.Home)}
          data-testid={testIds.favorites.delete.cancel}
        >
          Fortryd
        </Button>
      </div>
    </FocusContext.Provider>
  );
};

export default memo(FavoritesDelete);
